<template>
    <div class="inner-open-air">
        <div class="container">
            <div class="section-grid">
                <div class="column-container">
                    <div class="col-left">
                        <div class="section-grid-info inner-open-info">
                            <div class="title title-black title-small">
                                <h3 v-html="innerContentArr.section_open_air.title"></h3>
                            </div>
                            <div class="desc-html desc-html-black" v-html="innerContentArr.section_open_air.desc"></div>
                        </div>
                        <div class="section-grid-list-items bronze-list" v-if="!isMobileG">
                            <ul>
                                <li v-for="(item, index) in innerContentArr.section_open_air.list" :key="index" class="list-black">
                                    <p v-html="item.desc"></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-right">
                        <div class="section-images-grid section-oposite-mobile">
                            <div class="images-items">
                                <div class="item" v-for="(item, index) in innerContentArr.section_open_air.images" :key="index">
                                    <img :src="item.img" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="section-grid-list-items bronze-list" v-if="isMobileG">
                    <ul>
                        <li v-for="(item, index) in innerContentArr.section_open_air.list" :key="index" class="list-black">
                            <p v-html="item.desc"></p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    // import promoForm from '@/components/forms/form.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'inner-open-air',
        data () {
            return {
            }
        },
        computed: mapGetters({
            innerContentArr: 'loadInnerContent',
            isMobileG: 'loadisMobileGlobal',
        }),
        components: {
            // svgIcon,
            // promoForm,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/inner-content/inner-open-air.scss';
    @import '@/styles/components/inner-content/respond/inner-open-air-respond.scss';
</style>